<script setup>
import SiteFooter from '../components/layout/SiteFooter.vue'
import SiteHeader from '../components/layout/SiteHeader.vue'
</script>

<template>
  <div class="privacy-page">
    <SiteHeader />

    <main id="main-content" class="privacy-main">
      <article class="privacy-article">
        <header class="privacy-hero">
          <p class="privacy-hero__eyebrow">Me2 隐私政策</p>
          <h1>隐私政策</h1>
          <p class="privacy-hero__lead">
            欢迎你使用 Me2。Me2 由苏州乐享智能科技有限公司开发并运营。我们非常重视你的个人信息和隐私保护，并将按照合法、正当、必要、诚信、最小化原则处理你的个人信息。
          </p>
          <p class="privacy-hero__lead">
            本隐私政策适用于你通过 Me2 App 使用我们提供的产品和服务。
          </p>
          <div class="privacy-contact">
            <span class="privacy-contact__label">联系我们</span>
            <a class="privacy-contact__phone" href="tel:4008877096">400-8877-096</a>
          </div>
        </header>

        <section class="privacy-section">
          <h2>一、我们处理个人信息的范围</h2>
          <p>
            为向你提供账号登录、设备连接、文字轻聊、语音互动、在场陪伴、情绪感知、记录展示、设备升级、隐私管理等功能，我们会按照不同业务场景处理必要的个人信息。
          </p>

          <div class="privacy-block">
            <h3>1. 账号注册、登录与账号安全</h3>
            <p>当你使用手机号登录、短信验证码登录、密码登录、设置或修改密码、重置密码、注销账号等功能时，我们会处理以下信息：</p>
            <ul>
              <li>手机号码</li>
              <li>短信验证码</li>
              <li>登录密码</li>
              <li>用户 ID</li>
              <li>登录令牌（Token）</li>
            </ul>
            <p class="privacy-label">处理目的包括：</p>
            <ul>
              <li>完成用户身份验证</li>
              <li>保障账号安全</li>
              <li>支持登录态保持、找回密码、注销账号等能力</li>
            </ul>
          </div>

          <div class="privacy-block">
            <h3>2. 设备连接与设备管理</h3>
            <p>当你使用机器人连接、设备状态查看、设备升级等功能时，我们会处理以下信息：</p>
            <ul>
              <li>蓝牙连接状态</li>
              <li>设备序列号或设备标识信息</li>
              <li>设备版本信息、协议版本信息、电量状态、连接状态</li>
              <li>OTA 升级相关状态信息</li>
            </ul>
            <p class="privacy-label">处理目的包括：</p>
            <ul>
              <li>完成机器人设备连接和识别</li>
              <li>展示设备运行状态</li>
              <li>提供设备升级和异常排查能力</li>
            </ul>
          </div>

          <div class="privacy-block">
            <h3>3. 文字聊天与互动记录</h3>
            <p>当你使用文字轻聊、消息历史、互动记录等功能时，我们会处理以下信息：</p>
            <ul>
              <li>聊天文本内容</li>
              <li>消息记录</li>
              <li>与互动相关的时间、状态或结果信息</li>
            </ul>
            <p class="privacy-label">处理目的包括：</p>
            <ul>
              <li>返回文字回复</li>
              <li>展示历史消息和连续性上下文</li>
              <li>支持记录页和服务体验优化</li>
            </ul>
          </div>

          <div class="privacy-block">
            <h3>4. 语音互动与唤醒能力</h3>
            <p>当你启用麦克风权限并使用语音唤醒、语音互动、语音会话等功能时，我们会处理以下信息：</p>
            <ul>
              <li>麦克风采集的语音音频数据</li>
              <li>语音指令内容</li>
              <li>与语音互动相关的会话标识、状态信息</li>
            </ul>
            <p class="privacy-label">处理目的包括：</p>
            <ul>
              <li>识别你的语音输入</li>
              <li>触发语音互动</li>
              <li>返回语音回复或文本回复</li>
              <li>保障语音链路稳定运行</li>
            </ul>
            <aside class="privacy-note">
              <strong>说明</strong>
              <ul>
                <li>唤醒词检测优先在设备本地进行</li>
                <li>
                  当你实际发起语音互动时，相关语音数据可能上传至我们的服务器完成识别、理解、回复生成及语音合成
                </li>
              </ul>
            </aside>
          </div>

          <div class="privacy-block">
            <h3>5. 相机、在场感知与情绪分析</h3>
            <p>
              当你授权相机权限，并主动开启在场陪伴、注意力感知或情绪检测等功能时，我们会处理以下信息：
            </p>
            <ul>
              <li>相机画面</li>
              <li>面部图像或裁剪后的面部区域图像</li>
              <li>在场状态、注意力状态</li>
              <li>情绪分析结果</li>
            </ul>
            <p class="privacy-label">处理目的包括：</p>
            <ul>
              <li>判断在场状态与交互状态</li>
              <li>提供情绪分析与互动反馈</li>
              <li>生成互动记录、趋势摘要或展示结果</li>
            </ul>
            <aside class="privacy-note privacy-note--important">
              <strong>特别说明</strong>
              <ul>
                <li>面部图像、情绪分析结果属于敏感个人信息</li>
                <li>我们仅在你主动开启相关功能并授权后处理该类信息</li>
                <li>若你拒绝提供，不影响 App 的基础浏览和非相关功能使用，但相关功能将无法启用</li>
              </ul>
            </aside>
          </div>

          <div class="privacy-block">
            <h3>6. 个人资料管理</h3>
            <p>当你使用头像、昵称、邮箱、性别、生日、地区等资料管理功能时，我们会处理你主动填写或上传的信息，包括：</p>
            <ul>
              <li>头像</li>
              <li>昵称</li>
              <li>邮箱</li>
              <li>性别</li>
              <li>生日</li>
              <li>地区</li>
            </ul>
            <p class="privacy-label">处理目的包括：</p>
            <ul>
              <li>完善个人资料展示</li>
              <li>提升个性化体验</li>
              <li>在你的账号下同步和展示相关信息</li>
            </ul>
            <aside class="privacy-note">
              <strong>说明</strong>
              <p>
                当你更换头像时，我们将调用系统提供的文件选择器，由你主动选择一张图片文件进行上传。我们不会申请持续访问你相册内容的权限，也不会在未经你主动操作的情况下读取你的相册。
              </p>
            </aside>
          </div>

          <div class="privacy-block">
            <h3>7. 记录数据与派生结果</h3>
            <p>当你使用专注记录、情绪记录、成长记录等功能时，我们会处理以下信息：</p>
            <ul>
              <li>专注时长、专注次数</li>
              <li>情绪摘要、日度/周度结果、互动摘要</li>
              <li>与记录展示相关的时间、状态和统计信息</li>
            </ul>
            <p class="privacy-label">处理目的包括：</p>
            <ul>
              <li>展示你的记录和趋势</li>
              <li>支持连续性的陪伴体验</li>
              <li>优化服务质量</li>
            </ul>
          </div>

          <div class="privacy-block">
            <h3>8. 设备、网络与日志信息</h3>
            <p>为保障产品运行安全和服务稳定，我们可能处理以下信息：</p>
            <ul>
              <li>应用版本</li>
              <li>网络连接状态信息</li>
              <li>故障日志、操作日志、接口请求日志</li>
              <li>设备标识信息（ANDROID ID）</li>
              <li>重力传感器信息、方向传感器或姿态变化信息</li>
            </ul>
            <p class="privacy-label">处理目的包括：</p>
            <ul>
              <li>保障 App 正常运行</li>
              <li>提升稳定性和安全性</li>
              <li>进行故障排查、性能优化和风险控制</li>
              <li>适配设备姿态变化并优化交互与展示状态</li>
            </ul>
            <aside class="privacy-note">
              <strong>设备标识信息（ANDROID ID）</strong>
              <p>
                为识别应用运行设备环境、判断设备是否为模拟器，并辅助分析、定位应用崩溃、闪退及运行异常问题，在你同意本隐私政策后，Firebase
                Crashlytics SDK可能在初始化及崩溃诊断过程中，通过Android系统接口自动读取ANDROID
                ID。当前版本中，该信息用于设备本地运行环境判断，不用于账号身份识别、广告投放、用户画像或个性化推荐。
              </p>
            </aside>
            <aside class="privacy-note">
              <strong>重力传感器信息</strong>
              <p>
                为感知设备姿态变化、适配屏幕方向，并优化互动界面展示与相关交互体验，在你同意本隐私政策后，应用可能通过Android系统接口读取重力传感器数据。该信息仅在本地用于界面适配与交互优化，不会用于账号身份识别、广告投放、用户画像、个性化推荐，也不会用于追踪你的地理位置。
              </p>
            </aside>
          </div>
        </section>

        <section class="privacy-section">
          <h2>二、我们如何使用权限</h2>
          <p>Me2 可能向你申请以下系统权限：</p>
          <ul class="privacy-permissions">
            <li><strong>蓝牙权限</strong>：用于连接机器人设备、同步设备状态和执行设备管理功能</li>
            <li><strong>相机权限</strong>：用于在场感知、面部图像采集、情绪检测等功能</li>
            <li><strong>麦克风权限</strong>：用于语音唤醒、语音输入、语音互动等功能</li>
            <li><strong>网络权限</strong>：用于访问云端服务、同步账号信息和功能结果</li>
            <li>
              <strong>传感器权限（含重力传感器）</strong>：用于感知设备姿态与重力变化，适配屏幕方向，并优化交互和展示状态
            </li>
          </ul>
          <p>
            你可以在系统设置中关闭相关权限。关闭后，对应功能可能无法继续使用，但不会影响与该权限无关的其他功能。对于相机、麦克风等可能处理敏感个人信息的功能，我们会结合功能开关、权限请求、页面说明等方式向你告知处理目的、必要性、处理范围及对个人权益的影响；你可拒绝授权，拒绝不会影响其他无关功能，但对应功能将无法使用。
          </p>
        </section>

        <section class="privacy-section">
          <h2>三、敏感个人信息说明</h2>
          <p>在 Me2 的功能场景中，以下信息属于敏感个人信息：</p>
          <ul>
            <li>手机号码</li>
            <li>登录密码</li>
            <li>语音内容</li>
            <li>面部图像</li>
            <li>情绪分析结果</li>
          </ul>
          <p>
            我们仅在实现特定功能所必需、且取得你的单独同意或主动明确授权后处理该类信息，不会将处理敏感个人信息作为使用其他无关功能的前提。
          </p>
          <p class="privacy-label">敏感个人信息处理的必要性包括：</p>
          <ul>
            <li>
              为向你提供账号登录和账号安全能力，我们需要处理手机号码、登录密码等信息；若不处理，你将无法使用对应的登录、验证、找回密码或账号安全功能。
            </li>
            <li>
              为向你提供语音唤醒、语音互动、语音会话等能力，我们需要处理语音内容；若不处理，你将无法使用对应的语音功能。
            </li>
            <li>
              为向你提供在场陪伴、情绪检测、互动反馈和结果展示能力，我们需要处理面部图像、情绪分析结果；若不处理，你将无法使用与之对应的核心功能。
            </li>
          </ul>
          <p>
            处理敏感个人信息对个人权益的潜在影响包括：相关信息一旦泄露或被非法使用，可能导致你的人格尊严、人身安全、账户安全或隐私权益受到损害。为此，我们会对敏感个人信息采取比一般个人信息更严格的保护措施，包括访问控制、传输加密、最小权限、日志审计、身份验证和安全事件处置等。
          </p>
        </section>

        <section class="privacy-section">
          <h2>四、我们如何共享、转让、公开披露你的个人信息</h2>
          <div class="privacy-block">
            <h3>1. 共享</h3>
            <p>截至当前版本，我们不会将你的个人信息共享给第三方用于其独立的商业目的。</p>
          </div>
          <div class="privacy-block">
            <h3>2. 委托处理</h3>
            <p>
              为实现短信发送、云资源支撑、消息或文件上传、运维保障等服务，我们可能委托受托处理方在我们的委托范围内处理必要信息。Me2 的情绪检测能力由我们的自有系统或自研算法处理，不属于向第三方独立共享。我们会与受托处理方签署严格的数据保护协议，并要求其按照我们的要求、仅为实现本服务目的处理你的信息，不得超范围使用。
            </p>
          </div>
          <div class="privacy-block">
            <h3>3. 转让</h3>
            <p>除非获得你的单独同意，或法律法规另有规定，我们不会将你的个人信息转让给任何公司、组织和个人。</p>
          </div>
          <div class="privacy-block">
            <h3>4. 公开披露</h3>
            <p>除非获得你的单独同意，或法律法规另有规定，我们不会公开披露你的个人信息。</p>
          </div>
        </section>

        <section class="privacy-section">
          <h2>五、我们如何存储你的个人信息</h2>
          <div class="privacy-block">
            <h3>1. 存储地点</h3>
            <p>你的个人信息原则上将在中国大陆境内存储和处理。</p>
          </div>
          <div class="privacy-block">
            <h3>2. 保存期限</h3>
            <p>
              我们仅在实现处理目的所必需的最短期限内保存你的个人信息。你注销账号后，我们将立即停止基于该账号的所有个人信息处理活动，并对你的个人信息进行删除或匿名化处理。除非法律法规另有强制性留存要求，我们将仅对依法需要留存的数据进行隔离存储，并停止除存储和采取必要安全保护措施之外的处理活动。
            </p>
          </div>
          <div class="privacy-block">
            <h3>3. 特殊说明</h3>
            <p>
              原始语音音频、原始相机图像原则上仅在完成当次处理所需期间内处理，不作为长期展示内容保留；日志信息仅在实现故障排查、运行安全和合规要求所需的最短期限内保存。对于依法需要留存的数据，我们会在留存期限届满后按照法律法规要求删除或匿名化处理。
            </p>
          </div>
        </section>

        <section class="privacy-section">
          <h2>六、我们如何保护你的个人信息</h2>
          <p>我们采取包括但不限于以下措施保护你的个人信息：</p>
          <ul>
            <li>使用加密传输保护数据在传输过程中的安全</li>
            <li>通过最小权限控制和访问隔离保护数据访问安全</li>
            <li>对敏感操作进行日志记录和审计</li>
            <li>通过权限分级、身份验证等方式控制内部访问</li>
            <li>在发生安全事件时，依法依规及时处置并向你告知</li>
          </ul>
          <p>尽管如此，互联网并非绝对安全环境，请你妥善保管账号和密码信息。</p>
        </section>

        <section class="privacy-section">
          <h2>七、你的权利</h2>
          <p>在符合法律法规规定的前提下，你有权：</p>
          <ul>
            <li>访问、查阅你的个人信息</li>
            <li>更正、补充你的个人信息</li>
            <li>删除你的个人信息</li>
            <li>改变或撤回你的授权同意</li>
            <li>注销你的账号</li>
            <li>获取本隐私政策副本</li>
            <li>对我们的个人信息处理规则提出解释说明要求</li>
          </ul>
          <p>你可通过客服电话与我们联系。我们将在核验你的身份后及时处理。</p>
          <p class="privacy-label">关于删除你的个人信息：</p>
          <ul>
            <li>处理目的已实现、无法实现或者为实现处理目的不再必要</li>
            <li>我们停止提供产品或者服务</li>
            <li>你撤回同意（当处理基于同意时）</li>
            <li>你注销账号</li>
          </ul>
          <p>
            在上述情形中，我们将主动删除你的个人信息；如你主动请求删除，我们也将在核实身份后十五个工作日内予以删除。若法律法规规定的保存期限未届满，或者删除个人信息在技术上确有困难，我们将不会立即删除，但会停止除存储和采取必要安全保护措施之外的一切处理行为。
          </p>
        </section>

        <section class="privacy-section">
          <h2>八、未成年人保护</h2>
          <p>
            Me2 主要面向 18 周岁及以上成年人。我们不向未满 14 周岁的儿童提供产品和服务。如你未满 14 周岁，请勿使用本 App，也不要向我们提供你的个人信息。如你已满 14 周岁但未满 18 周岁，请在监护人指导并取得监护人同意后阅读、理解并使用本 App。
          </p>
          <p>
            如我们发现未经监护人同意处理了未满 14 周岁儿童的个人信息，我们将依法尽快停止处理并删除相关信息。监护人如发现相关情况，可通过客服电话与我们联系。
          </p>
        </section>

        <section class="privacy-section">
          <h2>九、本隐私政策的更新</h2>
          <p>
            我们可能根据产品功能更新、业务变化或法律法规要求对本隐私政策进行调整。如本隐私政策发生重大变更，包括但不限于我们的服务模式发生重大变化、个人信息处理目的或处理方式发生重大变化、你享有的个人信息权利发生重大变化等，我们将通过 App 弹窗、页面公告或其他合理方式向你告知，并在变更生效前再次征得你的明确同意。
          </p>
          <p>
            若你不同意更新后的政策，我们将停止为你提供相关服务或相应功能。对于非重大变更，更新后的隐私政策在发布后生效，我们会以适当方式提醒你查阅。
          </p>
        </section>

        <section class="privacy-section">
          <h2>十、联系我们</h2>
          <p>如你对本隐私政策或个人信息保护事宜有任何疑问、意见、建议或投诉举报，请通过以下方式联系我们：</p>
          <div class="privacy-contact privacy-contact--inline">
            <span class="privacy-contact__label">客服电话</span>
            <a class="privacy-contact__phone" href="tel:4008877096">400-8877-096</a>
          </div>
          <p>我们将在核验你的身份后尽快处理并回复。</p>
        </section>
      </article>
    </main>

    <SiteFooter />
  </div>
</template>

<style scoped>
.privacy-page {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background: #f7f7f5;
}

.privacy-main {
  flex: 1;
  padding: clamp(32px, 5vw, 56px) clamp(16px, 4vw, 32px) clamp(48px, 6vw, 72px);
}

.privacy-article {
  width: min(100%, 820px);
  margin: 0 auto;
  padding: clamp(28px, 4vw, 48px);
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.05);
}

.privacy-hero {
  padding-bottom: 32px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.privacy-hero__eyebrow {
  margin: 0 0 10px;
  color: rgba(0, 0, 0, 0.48);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.privacy-hero h1 {
  margin: 0;
  color: #000000;
  font-size: clamp(28px, 4vw, 40px);
  font-weight: 700;
  line-height: 1.2;
}

.privacy-hero__lead {
  margin: 16px 0 0;
  color: rgba(0, 0, 0, 0.72);
  font-size: 15px;
  line-height: 1.85;
}

.privacy-contact {
  display: inline-flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 24px;
  padding: 16px 20px;
  border-radius: 14px;
  background: #f8ffd9;
}

.privacy-contact--inline {
  margin-top: 16px;
  margin-bottom: 16px;
}

.privacy-contact__label {
  color: rgba(0, 0, 0, 0.56);
  font-size: 13px;
}

.privacy-contact__phone {
  color: #000000;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.privacy-section {
  padding-top: 36px;
}

.privacy-section + .privacy-section {
  margin-top: 0;
}

.privacy-section h2 {
  margin: 0 0 18px;
  padding-bottom: 12px;
  border-bottom: 3px solid #d4ff00;
  color: #000000;
  font-size: clamp(20px, 3vw, 24px);
  font-weight: 700;
  line-height: 1.35;
}

.privacy-section > p,
.privacy-block > p {
  margin: 0 0 14px;
  color: rgba(0, 0, 0, 0.72);
  font-size: 15px;
  line-height: 1.85;
}

.privacy-block {
  margin-top: 28px;
  padding: 22px 22px 20px;
  border-radius: 16px;
  background: #fafafa;
}

.privacy-block h3 {
  margin: 0 0 12px;
  color: #000000;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.4;
}

.privacy-label {
  margin-top: 18px !important;
  margin-bottom: 10px !important;
  color: #000000 !important;
  font-size: 14px !important;
  font-weight: 600;
}

.privacy-section ul,
.privacy-note ul {
  margin: 0 0 14px;
  padding-left: 1.25em;
  color: rgba(0, 0, 0, 0.72);
  font-size: 15px;
  line-height: 1.85;
}

.privacy-section ul li + li,
.privacy-note ul li + li {
  margin-top: 6px;
}

.privacy-permissions li strong {
  color: #000000;
  font-weight: 600;
}

.privacy-note {
  margin-top: 18px;
  padding: 16px 18px;
  border-left: 4px solid #d4ff00;
  border-radius: 0 12px 12px 0;
  background: rgba(212, 255, 0, 0.14);
}

.privacy-note--important {
  border-left-color: #000000;
  background: rgba(0, 0, 0, 0.04);
}

.privacy-note strong {
  display: block;
  margin-bottom: 8px;
  color: #000000;
  font-size: 14px;
}

.privacy-note p {
  margin: 0;
  color: rgba(0, 0, 0, 0.72);
  font-size: 14px;
  line-height: 1.8;
}

.privacy-note ul {
  margin-bottom: 0;
  font-size: 14px;
}

@media (max-width: 640px) {
  .privacy-article {
    padding: 20px 18px;
    border-radius: 18px;
  }

  .privacy-block {
    padding: 16px;
  }
}
</style>
